
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { KanbanState } from '../kanban.model';
import ViewSetting from './ViewSetting';
import AlwaysShowOwnBoardsSetting from './AlwaysShowOwnBoardsSetting';
import AdvancedUiSetting from './AdvancedUiSetting';
import LargePdfImageUiSetting from './LargePdfImageUiSetting';

@Component({
  name: 'UserSettingsDropdown',
  components: {
    AdvancedUiSetting,
    AlwaysShowOwnBoardsSetting,
    LargePdfImageUiSetting,
    ViewSetting,
  },
})
export default class UserSettingsDropdown extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;
}
